export const environment = {
  production: false,
  apiPath: 'https://dev-ventas.tiguanacaste.com/api',
  afiniaScriptURL:'https://dashboard.afinia.site/gatewaycdn/V1.1/AfiniaPaymentsandbox.min.js',
  afiniaKey:'eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRpZCI6IjUyZTVhYzM4LWE5ZTctNDMxOS1hNWVlLTg4Y2RiZGMwMWIxNCIsImNsaWVudG5hbWUiOiJjY2E4MzdiNS1iOWE4LTQ1ZDItODFkZS1mNWUxNzRmNjc5MmMiLCJwaG9uZW51bWJlciI6IjM0MjM1ZWExLWVmMzQtNGQ5ZC04ZGI4LTg4Zjk1YjhhODZhZCJ9.poyIazPhHXpN_-8YYSJrO03hfzMS2z9M2fQrZqQrvtc'
};
